import React, { useEffect, useState, useContext, useLayoutEffect } from "react";
import apiCalls from "shared/utils/apiCalls";
import CardSolution from "shared/components/CardSolution/CardSolution";
import Grid from "@material-ui/core/Grid";
import CardSolutionSkeleton from "shared/components/CardSolution/CardSolutionSkeleton/CardSolutionSkeleton";

import styles from "./Solutions.module.scss";
import Button from "shared/components/Buttons/Button";
import MUButton from "@material-ui/core/Button";
import { TuneRounded } from "@material-ui/icons";
import Modal from "shared/components/Modal/Modal";
import AppContext from "context/AppContext";
import Tags from "shared/components/Tags/Tags";

import cn from "classnames";
import { Checkbox, withStyles } from "@material-ui/core";
import { useLocation, useHistory } from "react-router-dom";
import { ReducerTypes } from "shared/types/reducerTypes";
import { debounce } from "shared/utils/debounce";

const checkBoxStyles = () => ({
  root: {
    "&$checked": {
      color: "var(--blue)",
    },
  },
  checked: {},
});

const CustomCheckbox = withStyles(checkBoxStyles)(Checkbox);

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Solutions = () => {
  const query = useQuery();
  const history = useHistory();

  const { state, dispatch } = useContext(AppContext);
  const [loading, setLoading] = useState<boolean>(false);

  const [filterModalOpen, setFilterModalOpen] = useState<boolean>(false);
  let template: any;

  useLayoutEffect(() => {
    // eslint-disable-next-line
    template = document.getElementById("containerDiv");

    template?.addEventListener("scroll", debounce(handleScroll));
    return () =>
      template?.removeEventListener("scroll", debounce(handleScroll));
  }, []);

  const handleScroll = () => {
    if (template?.clientHeight && template?.scrollTop) {
      if (
        template?.clientHeight + template?.scrollTop >=
        template?.scrollHeight - 300
      ) {
        if (!loading && !state.solutionsEnd) {
          document.getElementById("load-more-solutions")?.click();
        }
      }
    }
  };

  const goToNextPage = () => {
    dispatch({
      type: ReducerTypes.setSolutionsCurrentPage,
      payload: { value: state.solutionsCurrentPage + 1 },
    });
    getSolutions({ currentPage: state.solutionsCurrentPage + 1 });
  };

  useEffect(() => {
    if (state.solutionsCurrentPage < 0) {
      getSolutions({ currentPage: 0 });
      dispatch({
        type: ReducerTypes.setSolutionsCurrentPage,
        payload: { value: 0 },
      });
    }

    // eslint-disable-next-line
  }, []);

  const getSolutions = async ({
    clear,
    refresh,
    currentPage,
  }: {
    clear?: boolean;
    refresh?: boolean;
    currentPage: number;
  }) => {
    let url: string;
    let challengeId;
    setLoading(true);

    if (clear) {
      url = `/solutions?startIndex=0`;
    } else {
      if (!state.selectedChallengeId && query.get("challengeId")?.toString()) {
        challengeId = query.get("challengeId")?.toString();

        dispatch({
          type: ReducerTypes.setSelectedChallangeId,
          payload: { value: query.get("challengeId")?.toString() },
        });
      } else {
        challengeId = state.selectedChallengeId;
      }

      if (challengeId) {
        url = `/solutions?startIndex=${
          currentPage * 12
        }&challengeId=${challengeId}`;
      } else {
        url = `/solutions?startIndex=${currentPage * 12}`;
      }
    }

    const res = await apiCalls({
      method: "get",
      url,
    });

    if (res) {
      if (res.data.length < 12) {
        dispatch({
          type: ReducerTypes.setSolutionsEnd,
          payload: { value: true },
        });
      }

      if (refresh) {
        if (res.data.length > 0) {
          dispatch({
            type: ReducerTypes.setSolutions,
            payload: { value: [...res.data] },
          });
        }
      } else {
        if (res.data.length > 0) {
          dispatch({
            type: ReducerTypes.setSolutions,
            payload: { value: [...state.solutions, ...res.data] },
          });
        }
      }
    }

    setLoading(false);
  };

  const reset = () => {
    dispatch({
      type: ReducerTypes.setSolutionsCurrentPage,
      payload: { value: 0 },
    });

    dispatch({
      type: ReducerTypes.setSolutions,
      payload: { value: [] },
    });

    dispatch({
      type: ReducerTypes.setSolutionsEnd,
      payload: { value: false },
    });
  };

  const applyFilter = async () => {
    reset();
    history.push(`/solutions?challengeId=${state.selectedChallengeId}`);
    await getSolutions({
      refresh: true,
      currentPage: state.solutionsCurrentPage,
    });
    setFilterModalOpen(false);
  };

  const clear = async () => {
    dispatch({
      type: ReducerTypes.setSelectedChallange,
      payload: { value: undefined },
    });

    dispatch({
      type: ReducerTypes.setSelectedChallangeId,
      payload: { value: undefined },
    });

    history.push(`/solutions`);
    reset();
    await getSolutions({
      refresh: true,
      clear: true,
      currentPage: state.solutionsCurrentPage,
    });
    setFilterModalOpen(false);
  };

  const getNotifications = async () => {
    const res = await apiCalls({
      method: "get",
      url: `/notifications`,
    });

    if (res) {
      dispatch({
        type: ReducerTypes.getNotification,
        payload: { value: res.data },
      });
    }
  };

  useEffect(() => {
    getNotifications();

    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Modal
        open={filterModalOpen}
        closeModal={() => setFilterModalOpen(false)}
        size="sm"
        scrollable
        fullHeight
        footer={
          <div
            style={{
              padding: "var(--space-lg) var(--space-xl)",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            {state.selectedChallenge && (
              <span
                style={{
                  fontFamily: "var(--heading-font-family)",
                  color: "var(--grey-4)",
                  fontSize: "var(--text-sm)",
                }}
              >
                {state.selectedChallenge?.name}
              </span>
            )}
            <div
              style={{
                flexGrow: 1,
              }}
            />
            <Button
              onClick={applyFilter}
              loading={loading}
              aria-label="apply-filter"
            >
              Apply
            </Button>
          </div>
        }
      >
        <h4
          style={{
            color: "var(--grey-4)",
          }}
        >
          Filters
        </h4>

        <div
          style={{
            marginBottom: "var(--space-5xl)",
          }}
        >
          {state.challenges &&
            state.challenges.map((challenge: any) => (
              <button
                aria-label="challenge-filter"
                key={challenge.id}
                className={cn(styles.solutions_filters_challenge, {
                  [styles.solutions_filters_challenge__selected]:
                    challenge === state.selectedChallenge,
                })}
                onClick={() => {
                  dispatch({
                    type: ReducerTypes.setSelectedChallangeId,
                    payload: { value: challenge.id },
                  });

                  dispatch({
                    type: ReducerTypes.setSelectedChallange,
                    payload: { value: challenge },
                  });
                }}
              >
                <Grid container direction="row" spacing={3}>
                  <Grid item xs={7}>
                    <div className={styles.solutions_checkbox}>
                      <CustomCheckbox
                        disabled
                        color="default"
                        checked={challenge === state.selectedChallenge}
                        inputProps={{ "aria-label": challenge?.name }}
                      />
                      <label style={{ color: "var(--primary-text-color)" }}>
                        {challenge?.name}
                      </label>
                    </div>

                    <div className={styles.solutions_filters_challenge_tags}>
                      <Tags tags={challenge?.tags} />
                    </div>
                  </Grid>

                  <Grid item xs={5}>
                    <div
                      className={styles.solutions_filters_challenge_imgWrapper}
                    >
                      <img
                        loading="lazy"
                        src={challenge?.thumbnailImage}
                        alt={challenge?.name}
                      />
                    </div>
                  </Grid>
                </Grid>
              </button>
            ))}
        </div>
      </Modal>

      <div className={styles.solutions_headingRow}>
        <h1>Solutions</h1>

        <div
          style={{
            flexGrow: 1,
          }}
        />

        {(state.selectedChallengeId ||
          query.get("challengeId")?.toString()) && (
          <MUButton
            variant="text"
            type="button"
            style={{
              textTransform: "lowercase",
              fontFamily: "var(--heading-font-family)",
              color: "var(--blue-light)",
              fontSize: "var(--text-xs)",
              marginRight: "var(--space-xs)",
            }}
            size="small"
            onClick={clear}
          >
            clear
          </MUButton>
        )}

        <MUButton
          variant="text"
          type="button"
          style={{
            textTransform: "lowercase",
            fontFamily: "var(--heading-font-family)",
            color: "var(--grey-5)",
            fontSize: "var(--text-xs)",
            border: "1px solid var(--grey-4)",
          }}
          startIcon={
            <TuneRounded
              fontSize="inherit"
              style={{
                fontSize: "var(--text-xs)",
              }}
            />
          }
          size="small"
          onClick={() => setFilterModalOpen(true)}
        >
          filter
        </MUButton>
      </div>

      {state.solutions.length > 0 ? (
        <>
          <Grid container direction="row" spacing={3}>
            {state.solutions.map((solution: any) => (
              <Grid item xs={12} md={6} key={solution.id}>
                <CardSolution key={solution.id} solution={solution} />
              </Grid>
            ))}
          </Grid>
          {!state.solutionsEnd && (
            <div className={styles.solutions_buttonRow}>
              <Button
                id="load-more-solutions"
                aria-label="load more"
                loading={loading}
                onClick={goToNextPage}
                buttonVariant="default"
                textTransform="capitalize"
              >
                Load more..
              </Button>
            </div>
          )}
        </>
      ) : (
        <>
          {loading ? (
            <Grid container direction="row" spacing={3}>
              {[0, 1, 2, 3, 4, 5, 6, 7].map((number) => (
                <Grid item xs={12} md={6} key={number}>
                  <CardSolutionSkeleton key={number} />
                </Grid>
              ))}
            </Grid>
          ) : (
            <h3 style={{ color: "var(--grey-4)" }}>No Solutions Found</h3>
          )}
        </>
      )}
    </div>
  );
};

export default Solutions;
